import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import Footer from "components/footer/Footer";
import NotFound from "views/NotFound";
import {
  renderLayoutRoutes,
  getActiveRouteName,
  isKnownRoute,
} from "routeHelpers";

export default function Admin(props: { [x: string]: any }) {
  const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = React.useState(() => {
    if (typeof window === "undefined") {
      return false;
    }
    return window.innerWidth >= 1200;
  });

  const isValidRoute = React.useMemo(
    () => isKnownRoute(location.pathname, "/admin"),
    [location.pathname]
  );

  const currentRoute = React.useMemo(
    () => getActiveRouteName(location.pathname, "/admin", "Programs"),
    [location.pathname]
  );

  React.useEffect(() => {
    const handleResize = () => {
      setOpen(window.innerWidth >= 1200);
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="flex h-full w-full">
      <Sidebar
        open={open}
        onClose={() => {
          if (window.innerWidth < 1200) setOpen(false);
        }}
      />
      {/* Navbar & Main Content */}
      <div className="h-full w-full bg-lightPrimary dark:!bg-navy-900">
        {/* Main Content */}
        <main
          className={`mx-[12px] h-full flex-none transition-all md:pr-2 xl:ml-[313px]`}
        >
          {/* Routes */}
          <div className="h-full">
            {isValidRoute && (
              <Navbar
                onOpenSidenav={() => setOpen(!open)}
                brandText={currentRoute}
                {...rest}
              />
            )}
            <div
              className={`mx-auto mb-auto h-full min-h-[84vh] p-2 md:pr-2 ${
                isValidRoute ? "pt-5s" : "pt-0"
              }`}
            >
              <Routes>
                {renderLayoutRoutes("/admin")}

                <Route
                  path="/"
                  element={<Navigate to="/admin/programs" replace />}
                />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </div>
            <div className="p-2">
              <Footer />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
